import {creates, hoistCmp} from '@xh/hoist/core';
import {hframe} from '@xh/hoist/cmp/layout';
import './SecMaster.scss';
import {SecMasterTabModel} from './SecMasterTabModel';
import {panel} from '@xh/hoist/desktop/cmp/panel';
import {grid} from '@xh/hoist/cmp/grid';
import {securityGrid} from './impl/SecurityGrid';

export const secmasterTab = hoistCmp.factory({
    className: 'secmaster-tab',
    model: creates(SecMasterTabModel),
    render({model, className}) {
        return hframe({
            className,
            items: [
                panel({
                    modelConfig: {
                        side: 'left',
                        defaultSize: 200
                    },
                    item: grid({model: model.instrumentTreeModel})
                }),
                securityGrid({model: model.securityGridModel})
            ]
        });
    }
});
